export const LAST_VISITED_DEAL_QUERY = `
  query LastVisitedDealQuery($offerId: ID!) {
    me {
      userLastVisitedAt(offerId: $offerId)
    }
  }
`;
